/**
 *
 * GSAP Animation Helpers
 *
 * This is a helper class for using GSAP animations, methods in this class correspond to a CSS class that is used to trigger this animation
 *
 *
 * Steps to creating animations
 *
 * 1. create a function and add it to the proto object, pass in the element as a param
 * 2. create a css class in `_gsap.scss` and assign the initial state to the element
 * 3. assign the _Gsap function to the element in the document.load below
 * 4. Use Object.Assign to customize any default animations
 *
 *
 */
var $ = require('jQuery');


var _Gsap = (function () {

    var proto = {};

    proto.offset = '85%';

    proto.animations = {
        fadeInUp : {
            autoAlpha: 1,
            y: 0,
            delay : .1,
            ease: Elastic.easeOut.config(1, 0.3),
            lazy: true
        },
        slideInRight_start : {
            autoAlpha: 0,
            x: 150,
            ease: Power3.easeInOut

        },
        slideInLeft_start : {
            autoAlpha: 0,
            x: -150,
            ease: Power3.easeInOut
        },
        slideIn_end : {
            autoAlpha: 1,
            x: 0,
            ease: Power3.easeInOut
        },


    };

    proto.fadeInUp = function(el){

        TweenMax.staggerTo(
            $(el).children(),
            1.75,
            this.animations.fadeInUp,
            0.1
        );
    };

    proto.easeInUp = function (el) {

        let vars = Object.assign( {}, this.animations.fadeInUp, {  ease:  Back.easeOut.config(1.7)} );

        TweenMax.staggerTo(
            $(el).children(),
            1,
            vars,
            0.1
        );
    };

    proto.slideInSidesScroll = function(el){

        //if there is no intersection observer in browser, then play animation
        if (!'IntersectionObserver' in window){

            let tl = new window.TimelineMax()
                .set( el, {x:-150} )
                .to( el, 1, this.animations.slideIn_end );

            return;
        }

        //config
        const config = {
            rootMargin: '0px 0px -20% 0px',
        };

        //setup intersection observer instance
        let observer = new IntersectionObserver( (entries)=> {
            entries.forEach(entry => {

                //if we are intersecting then play animation
                if( entry.isIntersecting ){

                    //setup some variables to get the center position of window and the entry center
                    let entryCenter     = entry.boundingClientRect.left + entry.target.clientWidth;
                    let rootCenter      = entry.rootBounds.width / 2;
                    const elementSide     = (rootCenter <= entryCenter) ? 150 : -150;

                    let tl = new window.TimelineMax()
                        .set( entry.target, {x:elementSide} )
                        .to( entry.target, 1, this.animations.slideIn_end );

                    observer.unobserve( entry.target );

                }

            });
        }, config);


        observer.observe(el);


    };

    proto.slideSideStaggeredImages = function(el){

        //calculate the position of the element relative to the window
        const $el = $(el);
        const $windowWidth       = $(document).width() / 2; //get width of window
        const that               = this;

        const children  = $(el).children();

        children.waypoint({
            handler: function(direction) {

                //setting the variables for the slide inside the waypoint might be more accurate
                const $elLeftPosition    = $el.offset().left; //get the left position of the element in the window
                const centerX            = $el.outerWidth() / 2; //get the center of the element
                const $elSide            = ( $windowWidth <= ( $elLeftPosition + centerX)  ) ? 'slideInRight_start' : 'slideInLeft_start';

                TweenMax.fromTo(
                    this.element,
                    1,
                    that.animations[$elSide],
                    that.animations.slideIn_end,
                );

                this.destroy();

            },
            offset: that.offset
        });


    };

    proto.slideUpSelf = function(el){

        let vars            = Object.assign( {}, this.animations.fadeInUp, {  ease:  Circ.easeOut} );
        const $el           = $(el);
        const that          = this;

        $el.waypoint({
            handler: function(direction) {

                TweenMax.to(
                    this.element,
                    1,
                    vars,
                    0.1
                );

                this.destroy();

            },
            offset: that.offset
        });

    };

    proto.slideUpStaggeredChildren = function(el){

        let vars            = Object.assign( {}, this.animations.fadeInUp, { force3D: true, ease:  Circ.easeOut} );
        const $el           = $(el);
        const children      = $el.children();
        const that          = this;

        children.waypoint({
            handler: function(direction) {

                TweenMax.to(
                    this.element,
                    1,
                    vars,
                    0.1,
                );

                this.destroy();

            },
            offset: that.offset
        });

    };

    proto.slideUpStaggeredHeaders = function(el){

        let vars        = Object.assign( {}, this.animations.fadeInUp, {  ease:  Back.easeOut.config(1.7)} );
        const headers   = $(el).find( 'h1, h2' );
        const that      = this;

         headers.waypoint({
            handler: function(direction) {

                TweenMax.to(
                    this.element,
                    1,
                    vars,
                    0.1
                );

                this.destroy();

            },
            offset: that.offset
        });

    };

    proto.slideUpChildrenInSequence = function( el ){

        let vars        = Object.assign( {}, this.animations.fadeInUp, {  ease:  Back.easeOut.config(1.7)} );
        const $children = $(el).children();
        const that      = this;

        new Waypoint({
            element: el,
            handler: function (direction) {

                TweenMax.staggerTo(
                    $children,
                    1,
                    vars,
                    0.1
                );

                this.destroy();

            },
            offset: that.offset
        });

    };

    //animation for the success icon
    proto.confirmationAnimation = function( el ){

        //setup some variables
        const $el         = $(el);
        const $tick       = $el.find('.itbl-b-confirmation__tick');
        const $circle     = $el.find('.itbl-b-confirmation__circle');
        const $container  = $el.find('.itbl-c-form__confirmation-wrapper');

        var animate = new TimelineMax({delay:0.5});

        animate
            .set( $circle, {fillOpacity : 0 } )
            .set( $circle, {transform : 'scale(0)'} )
            .set( $tick,{strokeDashoffset: '29px'} )
            .set( $tick,{ strokeDasharry : '29px' })
            .set( $container, {yPercent: -100} )
            .set( $container, {autoAlpha: 1} )
            .addLabel('containerAnimationStart')
            .to( $container, .75, {yPercent: 0, ease: Elastic.easeOut.config(1, 1)} )
            .addLabel('circleAnimationStart')
            .to( $circle, .75, { transform: 'scale(.9)',ease: Elastic.easeOut.config(1, 1) }, 'circleAnimationStart' )
            .to( $circle, .2, {fillOpacity : 1 }, '-=.5' )
            .to( $tick, .8 ,{strokeDashoffset: '0', ease: Power3.easeInOut} );


    };


    return proto;
}());

$(document).ready(function(){

    $('.js-e-gsap--slideUp--staggered--load').each(function(){
        _Gsap.fadeInUp(this);
    });

    $('.js-e-gsap--easeup--staggered--load').each(function(){
        _Gsap.easeInUp(this);
    });

    $('.js-e-gsap--slideSide--self--scroll').each(function(){
        _Gsap.slideInSidesScroll(this);
    });

    $('.js-e-gsap--slideUp--staggered--scroll').each(function(){
        _Gsap.slideUpStaggeredChildren(this);
    });

    $('.js-e-gsap--slideup--self--scroll').each(function(){
        _Gsap.slideUpSelf(this);
    });

    $('.js-e-gsap--slideup--staggered-headers--scroll').each(function(){
        _Gsap.slideUpStaggeredHeaders(this);
    });

    $('.js-e-gsap--slideup--staggered--sequence--scroll').each(function(){
        _Gsap.slideUpChildrenInSequence(this);
    });

});

//setup module export
module.exports = _Gsap;
